import React from 'react';
import Translate from 'react-translate-component';

const YesNoFields = ({ value }) => value !== undefined ? (
    <Translate content={`common.${value ? 'yes' : 'no'}`} />
) : null;

export default YesNoFields;
